// extracted by mini-css-extract-plugin
module.exports = {"videoside":"Groups_videoside__1oymn","groupTitle":"Groups_groupTitle__pWlGE"};